import { render, staticRenderFns } from "./TServiceIcon.vue?vue&type=template&id=dae38ace"
import script from "./TServiceIcon.vue?vue&type=script&lang=js"
export * from "./TServiceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports